export default "images/实时路线导航+标志牌增强显示.png";